// v2.22.1 (owner 2026-10-29): the "File master desain" card in Pengaturan. An Owner sees and saves the
// UTAMA fields only; the Administrator (ADMIN_TEKNIS on the server) also gets LANJUTAN, closed by default.
// The server leaves LANJUTAN out for an Owner and refuses changes to it (app/services/admin_teknis.py).
// No imports, so Jest can test it.

// [field, label, unit, min, max]
export const ANGKA_UTAMA = [
  ["file_master_draf_hari", "Masa simpan draf", "hari", 1, 365],
  ["file_master_final_hari", "Masa simpan final", "hari", 1, 3650],
  ["file_master_maks_mb", "Ukuran maksimal per file", "MB", 1, 5120],
  ["file_master_kuota_gb_hari", "Kuota unggah per akun per hari", "GB", 1, 500],
  ["file_master_maks_versi", "Versi maksimal per SPK", "versi", 1, 500],
];
export const ANGKA_LANJUTAN = [
  ["file_master_batas_draf_hari", "Batas atas bucket: draf", "hari", 1, 3650],
  ["file_master_batas_final_hari", "Batas atas bucket: final", "hari", 1, 3650],
  ["file_master_bagian_bersamaan", "Bagian dikirim bersamaan", "bagian", 1, 6],
  ["file_master_tautan_unggah_menit", "Masa berlaku tautan unggah", "menit", 1, 60],
  ["file_master_tautan_unduh_menit", "Masa berlaku tautan unduh", "menit", 1, 60],
];
export const SEMUA_JENIS = ["cdr", "ai", "psd", "pdf", "png", "tif", "jpg", "eps"];

// what "Simpan" sends: an Owner never sends an advanced field
export function susunKirim(f, administrator) {
  const angka = administrator ? [...ANGKA_UTAMA, ...ANGKA_LANJUTAN] : ANGKA_UTAMA;
  const kirim = Object.fromEntries(angka.map(([k]) => [k, parseInt(f[k], 10)]));
  kirim.file_master_jenis = SEMUA_JENIS.filter((j) => (f.file_master_jenis || []).includes(j));
  if (administrator) {
    kirim.file_master_harga_gb_usd = Number(String(f.file_master_harga_gb_usd).replace(",", "."));
    kirim.file_master_kurs = parseInt(f.file_master_kurs, 10);
  }
  return kirim;
}

export const teksPenyimpanan = (aktif, administrator) =>
  aktif ? "aktif" : administrator ? "belum diaktifkan di server (R2_MODE=mati)" : "belum diaktifkan";
